import { useCallback, useEffect, useState } from 'react';
import { useQueryClient, useMutation } from 'react-query';
import { Alert, Select, Form, Popconfirm } from 'antd';
import srv from '../../../services';
import {
 SubmitButton,
 RangePicker,
 Col,
 BaseForm,
} from './MutualPayment.styled';
import moment, { Moment } from 'moment';
import DataGrid from '../../Shared/DataGrid/DataGrid';
import { MutualPaymentColumns } from '../../Shared/columns/MutualPaymentColumns';
import SnackBar from '../../Shared/SnackBar';

export default function MutualPayment() {
 const {
  data,
  form,
  error,
  isLoading,
  isSuccess,
  period,
  setPeriod,
  ...formProps
 } = useContractsPayment();
 const { contracts } = useDicts();

 const [mainColumns, setMainColumns] = useState(MutualPaymentColumns());

 useEffect(() => {
  const storyPaymentColumns = MutualPaymentColumns();

  setMainColumns(storyPaymentColumns);
 }, []);

 useEffect(() => {
  const picker = [moment(moment().subtract(12, 'months')), moment(new Date())];

  setPeriod({
   Picker: picker,
  });

  form.setFieldsValue({
   period: picker,
  });
 }, []);

 return (
  <>
   <BaseForm
    layout="vertical"
    form={form}
    {...formProps}
    style={{
     display: 'flex',
     width: '100%',
     flexDirection: 'row',
     justifyContent: 'flex-start',
     justifyItems: 'flex-start',
     alignContent: 'flex-start',
     alignItems: 'flex-start',
     textAlign: 'left',
    }}
   >
    <div style={{ minWidth: 400 }}>
     <Col>
      <Form.Item
       name="contractId"
       label="№ Договора"
       rules={[{ required: true }]}
       style={{ maxWidth: '400px', marginRight: 0 }}
      >
       <Select
        showSearch
        optionFilterProp="children"
        placeholder="Выберите № договора"
        loading={isLoading}
       >
        {contracts?.map((item) => (
         <Select.Option key={item.id} value={item.aisId}>
          {item.resources
           ? `${item.printNumber} - ${item.resources}`
           : item.printNumber}
         </Select.Option>
        ))}
       </Select>
      </Form.Item>
     </Col>
    </div>

    <Col flex={1.3}>
     <Form.Item
      name="period"
      label="Период запроса"
      rules={[{ required: true }]}
      style={{ maxWidth: '400px' }}
     >
      <RangePicker allowClear format="DD.MM.YYYY" style={{ width: '100%' }} />
     </Form.Item>
    </Col>

    {/* <Col flex={2.4}>
     <SubmitButton
      loading={isLoading}
      onClick={form.submit}
      disabled={isLoading}
     >
      Запросить
     </SubmitButton>
    </Col> */}

    {!!error && (
     <Alert
      type="error"
      showIcon
      message={error}
      style={{ width: '100%', marginTop: '10px' }}
     />
    )}

    {data && data.length > 0 && isSuccess && (
     <div style={{ width: '100%', marginLeft: '-15px' }}>
      <DataGrid
       columns={mainColumns?.columns ? mainColumns.columns : []}
       rows={data}
       take={20}
       page={1}
       pagination={true}
      />
     </div>
    )}
   </BaseForm>
   {/* {isSuccess ? <TableStoryPayment data={data} isLoading={isLoading} /> : null} */}

   <SnackBar vertical="top" horizontal="center" />
  </>
 );
}

function useContractsPayment() {
 const [form] = Form.useForm();

 const [period, setPeriod] = useState<any>([
  moment().subtract(12, 'months'),
  moment(new Date()),
 ]);

 const {
  data,
  mutate: save,
  isLoading,
  isSuccess,
  error,
  reset,
 } = useMutation(srv.requestDocumentsStoryPayment, {
  onSuccess: () => {
   //form.resetFields();
  },
 });

 const onFinish = useCallback(
  (values) => {
   save({
    contractId: values.contractId,
    periodStart: values.period[0],
    periodFinish: values.period[1],
   });
  },
  [save],
 );

 const onValuesChange = useCallback(
  (value) => {
   // if (value?.period) {
   //  return;
   // }

   if (error) reset();

   const values = form.getFieldsValue();

   if (
    values &&
    values.period &&
    values.period.length > 0 &&
    values.contractId
   ) {
    save({
     contractId: values.contractId,
     periodStart: values.period[0],
     periodFinish: values.period[1],
    });

    const picker = [values.period[0], values.period[1]];

    setPeriod({
     Picker: picker,
    });

    form.setFieldsValue({
     period: picker,
    });
   }
  },
  [error, reset],
 );

 return {
  data: data?.historyPay,
  form,
  error,
  isLoading,
  isSuccess,
  onFinish,
  onValuesChange,
  period,
  setPeriod,
 };
}

function useDicts() {
 const queryClient = useQueryClient();

 const contracts = queryClient.getQueryData<Models.Contract[]>('contracts');
 const services = queryClient.getQueryData<Models.Dict[]>('services');

 return { contracts, services };
}
